'use strict';

const kpis = {
  MARGIN: 'margin',
  VOLUME: 'volume',
  SELFSWITCHING: 'selfSwitching',
  UTILITY: 'utility',
  RANK: 'rank',
  SALES: 'sales',
  SHRINK: 'shrinkToSalesRatio',
  SHRINK_RATE_AT_CUT: 'shrinkRateAtCut',
};

module.exports = {
  kpis,
};
